import { Link } from 'react-router-dom';
import type { AnimeItem } from '@/mocks/animeData';

interface AnimeCardProps {
  anime: AnimeItem;
}

export default function AnimeCard({ anime }: AnimeCardProps) {
  return (
    <Link
      to={`/anime/${anime.id}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      {/* Cover */}
      <div className="relative overflow-hidden aspect-[3/4]">
        <img
          src={anime.cover}
          alt={anime.title}
          title={`${anime.title} - 51动漫在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {/* Status badge */}
        <div className="absolute top-3 left-3">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
            anime.status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {anime.status}
          </span>
        </div>
        {/* Rating */}
        <div className="absolute top-3 right-3 flex items-center gap-1 bg-background-950/60 backdrop-blur-sm px-2 py-0.5 rounded-full">
          <i className="ri-star-fill text-accent-500 text-xs" />
          <span className="text-background-50 text-xs font-medium">{anime.rating}</span>
        </div>
        {/* Hover overlay */}
        <div className="absolute inset-0 bg-background-950/0 group-hover:bg-background-950/20 transition-colors duration-300 flex items-end">
          <div className="w-full p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
            <span className="inline-block px-3 py-1.5 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
              立即观看
            </span>
          </div>
        </div>
      </div>

      {/* Info */}
      <div className="p-3 md:p-4">
        <h5 className="font-heading font-semibold text-foreground-900 text-sm md:text-base line-clamp-1 mb-1.5">
          {anime.title}
        </h5>
        <p className="text-foreground-500 text-xs line-clamp-2 leading-relaxed mb-3">
          {anime.shortDesc}
        </p>
        <div className="flex items-center justify-between">
          <div className="flex flex-wrap gap-1">
            {anime.tags.slice(0, 2).map((tag) => (
              <span key={tag} className="px-1.5 py-0.5 bg-secondary-100 text-secondary-700 rounded text-[10px] whitespace-nowrap">
                {tag}
              </span>
            ))}
          </div>
          <span className="text-foreground-400 text-[10px] whitespace-nowrap">
            {anime.views} 阅读
          </span>
        </div>
      </div>
    </Link>
  );
}